import React from 'react'
import PropTypes from 'prop-types'
import VisibilitySensor from 'react-visibility-sensor'

import {
  _DoughnutChartCont,
  _CircleEmpty,
  _Circle,
  _MiddleSvg,
} from './styles.js'

const circleWidth = 60
const stroke = 5


const DoughnutChartWithIcon = ({ percent, iconName }) => {
  const radius = (circleWidth - stroke) / 2
  const circumference = 2 * Math.PI * radius
  return (
    <_DoughnutChartCont>
      <VisibilitySensor>
        {({ isVisible }) => (
          <svg
            height={circleWidth}
            width={circleWidth}
            xmlns="http://www.w3.org/2000/svg"
          >
            <_CircleEmpty
              className="progress-ring__emptyCircle"
              strokeWidth="1"
              r={radius}
              cx={circleWidth / 2}
              cy={circleWidth / 2}
            />

            <_Circle
              className="progress-ring__circle"
              strokeWidth={stroke}
              r={radius}
              cx={circleWidth / 2}
              cy={circleWidth / 2}
              strokeDasharray={`${circumference} ${circumference}`}
              strokeDashoffset={
                isVisible ?
                  (-circumference + ((percent / 100) * circumference))
                  : -circumference
              }
            />
          </svg>
        )}
      </VisibilitySensor>

      <_MiddleSvg name={`#icon-demographics-${iconName}`} width={24} height={24} />
    </_DoughnutChartCont>
  )
}


DoughnutChartWithIcon.propTypes = {
  percent: PropTypes.number,
  iconName: PropTypes.string,
}

export default DoughnutChartWithIcon
